module.exports = __webpack_public_path__ + "img/carousel1.3d799475.webp";